import React from 'react';
import {View, Text, FlatList} from 'react-native';

const data = [
   {key: 'Item 1'},
   {key: 'Item 2'},
   {key: 'Item 3'},
   // Add more items as needed
];

const Rnd = () => {
   return (
      <View
         style={{
            flex: 1,
            /* justifyContent: 'center', */ alignItems: 'center',
         }}>
         <FlatList
            numColumns={3}
            data={data}
            renderItem={({item}) => (
               <View
                  style={{
                     //flex: 1,
                     justifyContent: 'center',
                     alignItems: 'center',
                     backgroundColor: 'red',
                     height: 200,
                     //width: 423,
                     maxWidth: 423,
                     margin: 4,
                  }}>
                  {/* Your item content */}
                  <Text>Hello</Text>
               </View>
            )}
         />
      </View>
   );
};

export default Rnd;
